export const KEY_BACKSPACE = 'Backspace'
export const KEY_ENTER = 'Enter'
export const KEY_TAB = 'Tab'
export const KEY_F2 = 'F2'
